<template>
  <div>
    <v-form>
      <v-text-field v-model="value.password" type="password" label="Password"></v-text-field>
      <v-text-field v-model="value.confirmPassword" type="password" label="Confirm Password"></v-text-field>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default() {
        return {
          password: "",
          confirmPassword: ""
        };
      }
    }
  }
};
</script>